import { configure } from "scrivito"

import { z } from "zod"

import { baseUrlForSite } from "./baseUrlForSite"
import { siteForUrl } from "./siteForUrl"

type Constraints = Record<string, { schema?: z.ZodTypeAny }>

export function configureScrivito(
  config?: Partial<Parameters<typeof configure>[0]>
) {
  configure({
    adoptUi: true,
    optimizedWidgetLoading: true,
    // strictSearchOperators: true,
    contentTagsForEmptyAttributes: false,
    tenant: import.meta.env.VITE_SCRIVITO_TENANT,
    siteForUrl,
    baseUrlForSite,
    extensionsUrl: "/_scrivito_extensions.html",
    constraintsValidation: constraints => {
      const name = Object.keys(constraints)[0]
      const { schema } = (constraints as Constraints)[name]

      return value => {
        if (!schema) return null
        const result = schema.safeParse(value)
        if (result.success) return null
        return {
          message: result.error.issues.map(issue => issue.message).join(", "),
          severity: "error"
        }
      }
    },
    ...config,
    instanceId: undefined
  })
}
